import { Component, EventEmitter, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Repository } from '../../../services/repository';
import { auditlichsuviewComponent } from '../quantri/auditlichsuview.component';

const swal = require('sweetalert');
const PHAN_HE_DUAN = '7F3A9C21-6B84-4E2D-9F1A-C8D05E47B3A6';

@Component({
  selector: 'app-danhmuc-duanedit',
  templateUrl: './duanedit.component.html',
  styleUrls: ['./duanedit.component.scss'],
  providers: [Repository],
  encapsulation: ViewEncapsulation.None
})
export class duaneditComponent {
  @Output() save = new EventEmitter<any>();
  @ViewChild('auditHistory', { static: false }) auditHistory: auditlichsuviewComponent;

  currentUser: any;
  phanHeId = PHAN_HE_DUAN;
  doituongSelect: any = {
    Id: 0, Ma: '', Ten: '', MoTa: '', SapXep: 1, Status: 1, UserName: null
  };

  constructor(private repo: Repository) { }

  loadDataInit(id: number, nhom: string, user: any) {
    this.currentUser = user;
    this.phanHeId = nhom || PHAN_HE_DUAN;
    if (!id) {
      this.doituongSelect = {
        Id: 0, Ma: '', Ten: '', MoTa: '', SapXep: 1, Status: 1,
        UserName: user ? user.user_name : null
      };
      return;
    }
    this.repo.getRequest('api/duan/getmodel/' + id).subscribe((res: any) => {
      this.doituongSelect = res || {};
      this.doituongSelect.UserName = user ? user.user_name : null;
    });
  }

  saveproduct() {
    if (!this.doituongSelect.Ten || !this.doituongSelect.Ten.trim()) {
      swal('Cảnh báo!', 'Nhập tên dự án', 'warning');
      return;
    }
    this.repo.postRequest('api/duan/addorupdate', this.doituongSelect).subscribe((res: any) => {
      if (typeof res === 'string' && isNaN(+res)) {
        swal('Lỗi!', res, 'error');
        return;
      }
      this.save.emit(this.doituongSelect);
    });
  }
}
